var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Grid, Select } from 'semantic-ui-react';
import FieldWithErrorDisplay from "../../FieldWithErrorDisplay";
var SelectSampleTypeForm = /** @class */ (function (_super) {
    __extends(SelectSampleTypeForm, _super);
    function SelectSampleTypeForm(props) {
        var _this = _super.call(this, props) || this;
        _this.sampleTypeOptions = function () {
            return _this.props.sampleTypes
                .map(function (t) { return ({
                text: t.label,
                value: t.id
            }); });
        };
        _this.onSampleTypeChange = function (event, data) {
            var val = _this.props.sampleTypes.find(function (v) { return v.id === data.value; });
            if (val === undefined) {
                throw new RangeError("Could not find sample type " + data.value);
            }
            var prevSampleType = _this.props.sampleTypeState.sampleType;
            var update = { sampleType: val };
            _this.props.onSampleTypeChange(update, prevSampleType, _this.props.onUserSelection);
        };
        return _this;
    }
    SelectSampleTypeForm.prototype.render = function () {
        return React.createElement(Grid, { columns: 4, textAlign: "left" },
            React.createElement(Grid.Row, null,
                React.createElement(Grid.Column, { textAlign: "left" },
                    React.createElement(FieldWithErrorDisplay, { errors: this.props.errors, errorPath: '/sampleType', labelContent: "", showErrors: this.props.showErrors },
                        React.createElement(Select, { className: "wide-dropdown", options: this.sampleTypeOptions(), onChange: this.onSampleTypeChange, placeholder: "Select...", selectOnNavigation: false, selectOnBlur: false, value: this.props.sampleTypeState.sampleType.id })))));
    };
    return SelectSampleTypeForm;
}(React.PureComponent));
export default SelectSampleTypeForm;
//# sourceMappingURL=SelectSampleTypeForm.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/kit/rna-fish/SelectSampleTypeForm.js
// module id = 130
// module chunks = 0